import { Button, CircularProgress, Grid, IconButton, Typography } from "@mui/material";
import api from "../../apiSetup/apiCall";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from 'react-toastify';
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { useEffect, useState } from "react";

const PopupImage = ({ id, images, onImageAdded, onImageDeleted }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [imageList, setImageList] = useState([]);

    useEffect(() => {
        if (Array.isArray(images)) {
            setImageList(images);
        } else {
            setImageList([]);
        }
    }, [images]);

    async function handleUpload(event) {
        const file = event.target.files[0];
        event.target.value = "";
        setIsLoading(true);

        if (!file) {
            toast.error("Please select a file to upload!");
            setIsLoading(false);
            return;
        }

        if (file.type !== "image/jpeg" && file.type !== "image/png") {
            toast.error("Only JPEG and PNG formats are allowed!");
            setIsLoading(false);
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            toast.error("File size should not exceed 5 MB!");
            setIsLoading(false);
            return;
        }
        
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = async () => {
                if (img.width !== 1080 || img.height !== 1920) {
                    toast.error("Image dimensions should be 1080 x 1920 pixels!");
                    setIsLoading(false);
                    return;
                }
                try {
                    const formData = new FormData();
                    formData.append('file', file);
                    const response = await api.put(`popup/image/${id}/`, formData, {
                        headers: { 'Content-Type': 'multipart/form-data'}
                    });

                    if (response?.data?.data) {
                        const newImageUrl = response.data.data;
                        onImageAdded(newImageUrl);
                        setIsLoading(false);
                    }
                } catch (error) {
                    setIsLoading(false);
                    toast.error('Error uploading file. Please retry!');
                }
            }
        };
    };

    async function removeImage(imageUrl) {
        setIsLoading(true);

        try {
            const response = await api.delete(`popup/image/${id}/`, {
                data: { image_url: imageUrl },
                headers: { 'Content-Type': 'application/json' }
            });
            if (response?.data?.success) {
                onImageDeleted(imageUrl);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            toast.error('Error removing file. Please retry !')
        }
    };

    return (
        <Grid item>
            {isLoading &&
                <Grid container justifyContent="center" alignItems="center" sx={{ height: "100%" }} >
                    <CircularProgress />
                </Grid>
            }

            {Array.isArray(imageList) && imageList.length > 0 && !isLoading &&
            <Grid container style={{ marginTop: "16px", gap: '10px' }}>
                {imageList.map((imageUrl) => (
                    <Grid item position="relative" sx={{ border: "1px solid rgba(0,0,0,0.5)", borderRadius: "10px", height: "100px" }}>
                        <div key={imageUrl} style={{position: "relative", width: "100%", height: "100%" }}>
                            <img src={imageUrl} alt="Upload popup" style={{ borderRadius: "10px", width: "100%", height: "100%" }} />
                            <IconButton onClick={() => removeImage(imageUrl)}  sx={{ position: "absolute", top: "-6px", right: "-6px", color: "red", padding: 0, backgroundColor: 'white'}}>
                                <CloseIcon sx={{ fontSize: "17px" }} />
                            </IconButton>
                        </div>
                    </Grid>
                ))}
            </Grid>
            }

            {(!Array.isArray(imageList) || imageList.length === 0) &&
                <Typography style={{ fontSize: "14px" }}>
                    <div style={{ color: "red", marginTop: "10px" }}>Popup image must be uploaded!</div>
                </Typography> 
            }            

            {(Array.isArray(imageList) && imageList.length <5) &&
                <Grid style={{ marginTop: "16px" }}>
                    <Button component="label" variant="outlined" startIcon={<UploadFileIcon />} style={{ color: "var(--gray-500, #667085)", fontFamily: "Inter", fontSize: "14px", fontWeight: "600", lineHeight: "18px" }}>
                        Upload
                        <input
                            type="file"
                            style={{ display: "none" }}
                            onChange={(event) => handleUpload(event)}
                            accept=".jpg, .jpeg, .png"
                        />
                    </Button>
                </Grid>            
            }

            {<Typography style={{ color: "red", fontSize: "12px" }}>
                <ul style={{ paddingLeft: 10 }}>
                    <li>Maximum upload 5 files.</li>
                    <li>Format must be JPEG or PNG.</li>
                    <li>Size per image should not exceed 5 MB.</li>
                    <li>Dimensions should be 1080 x 1920 pixels.</li>
                </ul>
            </Typography>}
        </Grid>
    );
};

export default PopupImage;
